import axios from 'axios';

/**
 * @function stringToHTML
 * Convert a template string into HTML DOM nodes
 * @param  {String} str The template string
 * @return {Node}       The template HTML
 */
function stringToHTML(str) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, 'text/html');
    return doc.body;
};

/**
 * @function generateSelect
 * 
 * @description Generate a select tag with the options in the specified ranges
 */

function generateSelect(options = [], attributes = {}) {


    let select = document.createElement('select');

    if (attributes.id) {
        select.setAttribute('id', attributes.id);
    }
    if (attributes.class) {
        select.setAttribute('class', attributes.class);
    }
    if (attributes['data-field-birthday']) {
        select.setAttribute('data-field-birthday', attributes['data-field-birthday']);
    }
    if (attributes['data-type']) {
        select.setAttribute('data-type', attributes['data-type']);
    }

    for (let index = 0; index < options.length; index++) {
        let option = document.createElement('option');
        option.value = options[index];
        option.innerText = options[index];

        select.appendChild(option);
    }

    return select;
}


/**
 * @function generateRank
 * 
 * @param {Int} from Initial value
 * @param {Int} to 	Final value
 * 
 * @description Create an array of integer from initial value to final value.
 * 
 * @returns Array of values.
 */

function generateRank(from = 10, to = 20) {
    let rank = [];
    for (let index = from; index <= to; index++) {
        rank.push(index);

    }
    return rank
}

/**
 * 
 * @function createQuestion
 * 
 * @param {String} title Title of the question
 * 
 * @description Send a request to the API to create a new question.
 * 
 * @returns UUID of the question or null if it failes.
 * 
 */


async function createQuestion(title) {
    try {
        let config = {
            method: 'post',
            url: '/question',
            data: {
                title
            }
        };
        const { data } = await axios(config);
        return data.values.uuid;
    } catch (e) {
        console.log(e);
        return null;
    }
}


/**
 * 
 * @function updateQuestion
 * 
 * @param {String} title Title of the question.
 * @param {String} uuid UUID of the question.
 * 
 * @description Send a request to the API to update a question.
 * 
 * @returns 1 if the question was updated or 0 if not.
 * Note: Answer 0 is not a fault only that there are no changes.
 * 
 */

async function updateQuestion(title, uuid, has_client = 0) {
    try {
        let config = {
            method: 'put',
            url: '/question/' + uuid,
            data: {
                title,
                has_client
            }
        };
        const { data } = await axios(config);
        return data.changed;

    } catch (e) {
        console.log(e);
        return null;
    }
}


/**
 * 
 * @function createOption
 * 
 * @param {String} name Name of the option.
 * @param {String} question_id UUID of the question.
 * 
 * @description Send a request to the API to create a new option.
 * 
 * @returns ID option.
 * 
 */

async function createOption(name, question_id, client_id = 0) {
    try {
        let config = {
            method: 'post',
            url: '/question_option',
            data: {
                name,
                question_id,
                sync: client_id
            }
        };
        const { data } = await axios(config);
        return data.values.id;
    } catch (e) {
        console.log(e);
        return null;
    }
}

/**
 * 
 * @function updateOption
 * 
 * @param {String} name Title of the option.
 * @param {String} option_id  uuid of the option.
 * 
 * @description Send a request to the API to update a option.
 * 
 * @returns The data of the response.
 * 
 * 
 */

async function updateOption(name, option_id, client_id = 0) {
    // Developing.
    try {
        let config = {
            method: 'put',
            url: '/question_option/' + option_id,
            data: {
                name,
                sync: client_id
            }
        };
        const { data } = await axios(config);
        return data.changed;
    } catch (e) {
        console.log(e);
        return null;
    }
}


function generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}


function arrayUnique(array) {
    let a = array.concat();
    let resp = [];
    for (let i = 0; i < a.length; i++) {
        let exists = resp.find((item) => item.name == a[i].name);
        if (!exists) {
            let to_push = a[i];
            resp.push(to_push);
        }
    }
    return resp;
}

/**
 * @function createNewStep
 * 
 * @param {String} template_id
 * @param {Int} rank
 * 
 * @description Create a new step.
 * @returns New step data
 */
async function createNewStep(template_id, order_step = 0, data_step = {}) {

    try {
        let config = {
            method: 'post',
            url: '/template_step',
            data: {
                template_id,
                order_step,
                ...data_step
            }
        };
        // await data of the new step rank.
        const { data } = await axios(config);
        return data.values;
    } catch (e) {
        console.log(e);
        return null;
    }
}

async function loadStep(step_id) {
    try {
        let config = {
            method: 'get',
            url: '/template_step/' + step_id,
        };

        // await data of the new step rank.
        const { data } = await axios(config);
        return data;
    } catch (e) {
        console.log(e);
        return null;
    }
}


async function storeStep(step_id, data_step) {
    try {
        let config = {
            method: 'put',
            url: '/template_step/' + step_id,
            data: {
                ...data_step
            }
        };

        // await data of the new step rank.
        const { data } = await axios(config);
        return data;
    } catch (e) {
        console.log(e);
        return null;
    }
}

/**
 * @function getListSteps
 * @param {*} template_id 
 * @param {*} opts 
 * @description Obtenga una lista del historial de la plantilla actual.
 * @returns Array with object steps.
 */

async function getListSteps(uuid) {
    if (!uuid) return null;
    try {
        let config = {
            method: 'GET',
            url: `/templates.api/${uuid}/steps`,
            params: { query: { order: { order_step: "asc" } } },
            withCredentials: true,
            credentials: 'same-origin',
        };

        // await data of the new step rank.
        const { data } = await axios(config);
        return data._items;
    } catch (e) {
        console.log(e);
        return null
    }

}

/**
 * @function deleteStep
 * @param {*} step_id 
 * @param {*} opts 
 * 
 * @description  Delete a step by id.
 * @returns data with 1 is deleted or 0 if not.
 */
async function deleteStep(template, step) {
    try {
        let config = {
            method: 'DELETE',
            url: `/templates.api/${template.uuid}/steps/${step.uuid}/delete`,
        };

        // await data of the new step rank.
        const { data } = await axios(config);
        return data;
    } catch (e) {
        console.log(e);
        return null;
    }
}

/**
 * @function createNewStepRank
 * 
 * @param {String} id ID of the current step
 * @param {String} template_id
 * @param {Object} opts Options of the grapesjs plugin
 * 
 * @description Create a new rank in the current step.
 * @returns New step data.
 */
async function createNewStepRank(id, template_id, opts = {}) {

    try {
        let config = {
            method: 'post',
            url: '/template_step/',
            data: {
                template_id,
                id
            }
        };

        // await data of the new step rank.
        const { data } = await axios(config);
        return data;
    } catch (e) {
        console.log(e);
        return null;
    }
}

/**
 * 
 * @function createQuestionTemplateStep
 * @param {*} question_id 
 * @param {*} template_step_id 
 * @description Create the relationship between the question and the current step 
 */
async function createQuestionTemplateStep(question_id, template_step_id) {
    try {
        let config = {
            method: 'post',
            url: '/question_template_step',
            data: {
                question_id,
                template_step_id
            }
        };
        const { data } = await axios(config);
        return data;
    } catch (e) {
        console.log(e);
        return null;
    }
}

async function getTemplateInfo(template_uuid) {
    try {
        let config = {
            method: 'get',
            url: '/template/' + template_uuid,
        };
        const { data } = await axios(config);
        return data;
    } catch (e) {
        console.log(e);
        throw e;
    }
}
async function updateTemplateInfo(template_uuid, data_update) {
    try {
        let config = {
            method: 'put',
            url: '/template/' + template_uuid,
            data: {
                ...data_update
            }
        };
        const { data } = await axios(config);
        return data;
    } catch (e) {
        console.log(e);
        throw e;
    }
}

export {
    stringToHTML,
    generateSelect,
    generateRank,
    createQuestion,
    updateQuestion,
    createOption,
    updateOption,
    generateUUID,
    createNewStepRank,
    createQuestionTemplateStep,
    createNewStep,
    storeStep,
    loadStep,
    getListSteps,
    deleteStep,
    getTemplateInfo,
    updateTemplateInfo,
    arrayUnique
}

